import {createTheme} from "@mui/material";
import baseTheme from "./baseTheme";

export const lightTheme = createTheme(baseTheme, {
  palette: {
    mode: "light",
    colors: {
      primary: "#10458c",
      secondary: "#C00B6C",
      white: "#FFFFFF",
      background: "#FFFFFF",
      blue: "#2F80ED",
      blueBG: "#E3F2FD",
      green: "#27AE60",
      greenBG: "#E8F8EF",
      pink: "#EE3B7A",
      pinkBG: "#FDEAF1",
      orange: "#F2994A",
      orangeBG: "#FEF3E6"
    },
    text: {
      primary: "#1E1E1E",
      secondary: "#646464",
      title: "#10458c",
      divider: "#E0E0E0"
    },
    sidebar: {
      background: "#0e1e34",
      border: "#0e1e34",
      title: "#FFFFFF",
      itemText: "#FFFFFF",
      itemHoverBg: "#069CD9",
      itemHoverText: "#FFFFFF"
    },
    windowScreen: {
      background: "#fafbfe",
      headerBackground: "#0e1e34",
      title: "#FFFFFF"
    },
    card: {
      background: "#FFFFFF",
      border: "#ebeaeb",
      borderRadius: "12px",
      borderShadow: "3px 3px 10px rgba(20, 43, 69, 0.1)"
    },
    listView: {
      headerBackground: "#ECF0FB",
      headerText: "#56697C",
      rowHoverBackground: "#FAFBFF"
    },
    components: {
      SnackbarContent: {
        styleOverrides: {
          root: {
            "&.notistack-MuiContent-copy": {
              backgroundColor: "#d4edda !important",
              color: "#155724 !important",
              border: "1px solid #c3e6cb !important",
              borderRadius: "4px !important"
            }
          }
        }
      }
    }
  }
});

export const darkTheme = createTheme(baseTheme, {
  palette: {
    mode: "dark",
    colors: {
      primary: "#10458c",
      secondary: "#C00B6C",
      background: "#2c2c2c",
      blue: "#8AB9FF",
      blueBG: "rgba(47, 128, 237, 0.18)",
      green: "#27AE60",
      greenBG: "rgba(39, 174, 96, 0.18)",
      pink: "#EB5292",
      pinkBG: "rgba(235, 82, 146, 0.2)",
      orange: "#F2994A",
      orangeBG: "rgba(242, 153, 74, 0.2)"
    },
    text: {
      primary: "#FFFFFF",
      secondary: "#CCCCCC",
      title: "#FFFFFF",
      divider: "#444444"
    },
    sidebar: {
      background: "#191919",
      border: "#191919",
      title: "#5AC0F0",
      itemText: "#FFFFFF",
      itemHoverBg: "#069CD9",
      itemHoverText: "#FFFFFF"
    },
    windowScreen: {
      background: "#1d1d1d",
      headerBackground: "#191919",
      title: "#FFFFFF"
    },
    card: {
      background: "#252525",
      border: "#171717",
      borderRadius: "12px",
      borderShadow: "3px 3px 10px rgba(20, 43, 69, 0.1)"
    },
    listView: {
      headerBackground: "#2f2f2f",
      headerText: "#CCCCCC",
      rowHoverBackground: "#333333"
    },
    components: {
      SnackbarContent: {
        styleOverrides: {
          root: {
            "&.notistack-MuiContent-copy": {
              backgroundColor: "#d4edda !important",
              color: "#155724 !important",
              border: "1px solid #c3e6cb !important",
              borderRadius: "4px !important"
            }
          }
        }
      }
    }
  }
});
